var map = {
	"./": 3220,
	"./AdminPage": 27377,
	"./AdminPage.js": 27377,
	"./AdminPage.scss": 14117,
	"./App": 20243,
	"./App.js": 20243,
	"./App.scss": 16245,
	"./Page": 27589,
	"./Page.js": 27589,
	"./Page.scss": 29344,
	"./PreviousGames": 76289,
	"./PreviousGames.js": 76289,
	"./PreviousGames.scss": 41664,
	"./components/GuessBar": 27992,
	"./components/GuessBar.js": 27992,
	"./components/GuessBar.scss": 3413,
	"./components/Header": 75563,
	"./components/Header.js": 75563,
	"./components/Header.scss": 27216,
	"./components/HintPanel": 97925,
	"./components/HintPanel.js": 97925,
	"./components/HintPanel.scss": 59996,
	"./components/Popups/HowToPlay": 65391,
	"./components/Popups/HowToPlay.js": 65391,
	"./components/Popups/HowToPlay.scss": 57498,
	"./components/Popups/Popup": 17633,
	"./components/Popups/Popup.js": 17633,
	"./components/Popups/Popup.scss": 1612,
	"./components/Popups/Stats": 69015,
	"./components/Popups/Stats.js": 69015,
	"./components/Popups/Stats.scss": 48067,
	"./components/ReplayEntry": 35996,
	"./components/ReplayEntry.js": 35996,
	"./components/ReplayEntry.scss": 64757,
	"./components/Results": 67241,
	"./components/Results.js": 67241,
	"./components/Results.scss": 12309,
	"./components/TimeToNext": 44006,
	"./components/TimeToNext.js": 44006,
	"./components/TrackPlayer": 54695,
	"./components/TrackPlayer.js": 54695,
	"./components/TrackPlayer.scss": 75257,
	"./data/consoles": 49450,
	"./data/consoles.json": 49450,
	"./data/games": 21936,
	"./data/games.json": 21936,
	"./data/songs": 27052,
	"./data/songs.json": 27052,
	"./index": 3220,
	"./index.js": 3220,
	"./index.scss": 31916,
	"./lib/game": 37718,
	"./lib/game.js": 37718,
	"./lib/pseudo-rng": 10404,
	"./lib/pseudo-rng.js": 10404,
	"./reportWebVitals": 79167,
	"./reportWebVitals.js": 79167,
	"./shared.scss": 78629,
	"./tracks/AceAttorney_Cornered/track_01.mp3": 18004,
	"./tracks/AceAttorney_Cornered/track_02.mp3": 1249,
	"./tracks/AceAttorney_Cornered/track_03.mp3": 5651,
	"./tracks/AceAttorney_Cornered/track_04.mp3": 20225,
	"./tracks/AceAttorney_Cornered/track_05.mp3": 19953,
	"./tracks/AceAttorney_Godot/track_01.mp3": 12440,
	"./tracks/AceAttorney_Godot/track_02.mp3": 13066,
	"./tracks/AceAttorney_Godot/track_03.mp3": 49319,
	"./tracks/AceAttorney_Godot/track_04.mp3": 85971,
	"./tracks/AceAttorney_Godot/track_05.mp3": 34224,
	"./tracks/AnimalCrossingCityFolk_TitleScreen/track_01.mp3": 71719,
	"./tracks/AnimalCrossingCityFolk_TitleScreen/track_02.mp3": 43917,
	"./tracks/AnimalCrossingCityFolk_TitleScreen/track_03.mp3": 73580,
	"./tracks/AnimalCrossingCityFolk_TitleScreen/track_04.mp3": 20984,
	"./tracks/AnimalCrossingCityFolk_TitleScreen/track_05.mp3": 37402,
	"./tracks/BanjoKazooie_Intro/track_01.mp3": 21020,
	"./tracks/BanjoKazooie_Intro/track_02.mp3": 35426,
	"./tracks/BanjoKazooie_Intro/track_03.mp3": 79137,
	"./tracks/BanjoKazooie_Intro/track_04.mp3": 12115,
	"./tracks/BanjoKazooie_Intro/track_05.mp3": 20332,
	"./tracks/BanjoKazooie_MumbosMountain/track_01.mp3": 69878,
	"./tracks/BanjoKazooie_MumbosMountain/track_02.mp3": 17026,
	"./tracks/BanjoKazooie_MumbosMountain/track_03.mp3": 29088,
	"./tracks/BanjoKazooie_MumbosMountain/track_04.mp3": 86923,
	"./tracks/BanjoKazooie_MumbosMountain/track_05.mp3": 60217,
	"./tracks/BanjoKazooie_TreasureTrove/track_01.mp3": 34879,
	"./tracks/BanjoKazooie_TreasureTrove/track_02.mp3": 89453,
	"./tracks/BanjoKazooie_TreasureTrove/track_03.mp3": 88216,
	"./tracks/BanjoKazooie_TreasureTrove/track_04.mp3": 95021,
	"./tracks/BanjoKazooie_TreasureTrove/track_05.mp3": 70715,
	"./tracks/BombermanHero_Redial/track_01.mp3": 77279,
	"./tracks/BombermanHero_Redial/track_02.mp3": 53583,
	"./tracks/BombermanHero_Redial/track_03.mp3": 10623,
	"./tracks/BombermanHero_Redial/track_04.mp3": 52647,
	"./tracks/BombermanHero_Redial/track_05.mp3": 35478,
	"./tracks/BubbleBobble_Theme/track_01.mp3": 44195,
	"./tracks/BubbleBobble_Theme/track_02.mp3": 45569,
	"./tracks/BubbleBobble_Theme/track_03.mp3": 43338,
	"./tracks/BubbleBobble_Theme/track_04.mp3": 6517,
	"./tracks/BubbleBobble_Theme/track_05.mp3": 8197,
	"./tracks/Castlevania2_BloodyTears/track_01.mp3": 50572,
	"./tracks/Castlevania2_BloodyTears/track_02.mp3": 21125,
	"./tracks/Castlevania2_BloodyTears/track_03.mp3": 37018,
	"./tracks/Castlevania2_BloodyTears/track_04.mp3": 970,
	"./tracks/Castlevania2_BloodyTears/track_05.mp3": 11473,
	"./tracks/Castlevania3_Beginning/track_01.mp3": 89382,
	"./tracks/Castlevania3_Beginning/track_02.mp3": 95422,
	"./tracks/Castlevania3_Beginning/track_03.mp3": 56962,
	"./tracks/Castlevania3_Beginning/track_04.mp3": 57544,
	"./tracks/Castlevania3_Beginning/track_05.mp3": 68878,
	"./tracks/Castlevania_VampireKiller/track_01.mp3": 79918,
	"./tracks/Castlevania_VampireKiller/track_02.mp3": 50940,
	"./tracks/Castlevania_VampireKiller/track_03.mp3": 51891,
	"./tracks/Castlevania_VampireKiller/track_04.mp3": 38537,
	"./tracks/Castlevania_VampireKiller/track_05.mp3": 36516,
	"./tracks/CaveStory_Geothermal/track_01.mp3": 29729,
	"./tracks/CaveStory_Geothermal/track_02.mp3": 16641,
	"./tracks/CaveStory_Geothermal/track_03.mp3": 30285,
	"./tracks/CaveStory_Geothermal/track_04.mp3": 83828,
	"./tracks/CaveStory_Geothermal/track_05.mp3": 92612,
	"./tracks/CaveStory_MoonSong/track_01.mp3": 78322,
	"./tracks/CaveStory_MoonSong/track_02.mp3": 14975,
	"./tracks/CaveStory_MoonSong/track_03.mp3": 72005,
	"./tracks/CaveStory_MoonSong/track_04.mp3": 79833,
	"./tracks/CaveStory_MoonSong/track_05.mp3": 1414,
	"./tracks/CaveStory_TitleTheme/track_01.mp3": 22905,
	"./tracks/CaveStory_TitleTheme/track_02.mp3": 54358,
	"./tracks/CaveStory_TitleTheme/track_03.mp3": 71184,
	"./tracks/CaveStory_TitleTheme/track_04.mp3": 49415,
	"./tracks/CaveStory_TitleTheme/track_05.mp3": 24725,
	"./tracks/Celeste_Resurrections/track_01.mp3": 86837,
	"./tracks/Celeste_Resurrections/track_02.mp3": 21375,
	"./tracks/Celeste_Resurrections/track_03.mp3": 49013,
	"./tracks/Celeste_Resurrections/track_04.mp3": 94139,
	"./tracks/Celeste_Resurrections/track_05.mp3": 55680,
	"./tracks/ChronoTrigger_CorridorsOfTime/track_01.mp3": 49988,
	"./tracks/ChronoTrigger_CorridorsOfTime/track_02.mp3": 66645,
	"./tracks/ChronoTrigger_CorridorsOfTime/track_03.mp3": 30376,
	"./tracks/ChronoTrigger_CorridorsOfTime/track_04.mp3": 46213,
	"./tracks/ChronoTrigger_CorridorsOfTime/track_05.mp3": 62488,
	"./tracks/ChronoTrigger_SecretOfForest/track_01.mp3": 28282,
	"./tracks/ChronoTrigger_SecretOfForest/track_02.mp3": 98890,
	"./tracks/ChronoTrigger_SecretOfForest/track_03.mp3": 32211,
	"./tracks/ChronoTrigger_SecretOfForest/track_04.mp3": 31167,
	"./tracks/ChronoTrigger_SecretOfForest/track_05.mp3": 18020,
	"./tracks/DiddyKongRacing_Pirate/track_01.mp3": 44355,
	"./tracks/DiddyKongRacing_Pirate/track_02.mp3": 89578,
	"./tracks/DiddyKongRacing_Pirate/track_03.mp3": 88086,
	"./tracks/DiddyKongRacing_Pirate/track_04.mp3": 646,
	"./tracks/DiddyKongRacing_Pirate/track_05.mp3": 59101,
	"./tracks/DonkeyKongCountry2_Stickerbrush/track_01.mp3": 76765,
	"./tracks/DonkeyKongCountry2_Stickerbrush/track_02.mp3": 32914,
	"./tracks/DonkeyKongCountry2_Stickerbrush/track_03.mp3": 40282,
	"./tracks/DonkeyKongCountry2_Stickerbrush/track_04.mp3": 88705,
	"./tracks/DonkeyKongCountry2_Stickerbrush/track_05.mp3": 93385,
	"./tracks/DonkeyKongCountry_AquaticAmbience/track_01.mp3": 13670,
	"./tracks/DonkeyKongCountry_AquaticAmbience/track_02.mp3": 99543,
	"./tracks/DonkeyKongCountry_AquaticAmbience/track_03.mp3": 10546,
	"./tracks/DonkeyKongCountry_AquaticAmbience/track_04.mp3": 96337,
	"./tracks/DonkeyKongCountry_AquaticAmbience/track_05.mp3": 86814,
	"./tracks/DonkeyKongCountry_JungleGroove/track_01.mp3": 88752,
	"./tracks/DonkeyKongCountry_JungleGroove/track_02.mp3": 49234,
	"./tracks/DonkeyKongCountry_JungleGroove/track_03.mp3": 1956,
	"./tracks/DonkeyKongCountry_JungleGroove/track_04.mp3": 38881,
	"./tracks/DonkeyKongCountry_JungleGroove/track_05.mp3": 75977,
	"./tracks/DonkeyKongCountry_TitleTheme/track_01.mp3": 25503,
	"./tracks/DonkeyKongCountry_TitleTheme/track_02.mp3": 86850,
	"./tracks/DonkeyKongCountry_TitleTheme/track_03.mp3": 15103,
	"./tracks/DonkeyKongCountry_TitleTheme/track_04.mp3": 18504,
	"./tracks/DonkeyKongCountry_TitleTheme/track_05.mp3": 67794,
	"./tracks/DoubleDragon_TitleTheme/track_01.mp3": 39786,
	"./tracks/DoubleDragon_TitleTheme/track_02.mp3": 68916,
	"./tracks/DoubleDragon_TitleTheme/track_03.mp3": 53662,
	"./tracks/DoubleDragon_TitleTheme/track_04.mp3": 23356,
	"./tracks/DoubleDragon_TitleTheme/track_05.mp3": 88143,
	"./tracks/DuckTales_Intro/track_01.mp3": 1312,
	"./tracks/DuckTales_Intro/track_02.mp3": 50252,
	"./tracks/DuckTales_Intro/track_03.mp3": 97095,
	"./tracks/DuckTales_Intro/track_04.mp3": 69018,
	"./tracks/DuckTales_Intro/track_05.mp3": 69558,
	"./tracks/DuckTales_Moon/track_01.mp3": 66972,
	"./tracks/DuckTales_Moon/track_02.mp3": 2823,
	"./tracks/DuckTales_Moon/track_03.mp3": 6847,
	"./tracks/DuckTales_Moon/track_04.mp3": 28538,
	"./tracks/DuckTales_Moon/track_05.mp3": 62053,
	"./tracks/Earthbound_Onett/track_01.mp3": 23934,
	"./tracks/Earthbound_Onett/track_02.mp3": 95008,
	"./tracks/Earthbound_Onett/track_03.mp3": 63054,
	"./tracks/Earthbound_Onett/track_04.mp3": 18265,
	"./tracks/Earthbound_Onett/track_05.mp3": 93708,
	"./tracks/Earthbound_SanctuaryGuardian/track_01.mp3": 83384,
	"./tracks/Earthbound_SanctuaryGuardian/track_02.mp3": 80463,
	"./tracks/Earthbound_SanctuaryGuardian/track_03.mp3": 82339,
	"./tracks/Earthbound_SanctuaryGuardian/track_04.mp3": 169,
	"./tracks/Earthbound_SanctuaryGuardian/track_05.mp3": 76696,
	"./tracks/Earthbound_WeakOpponent/track_01.mp3": 8293,
	"./tracks/Earthbound_WeakOpponent/track_02.mp3": 65612,
	"./tracks/Earthbound_WeakOpponent/track_03.mp3": 93410,
	"./tracks/Earthbound_WeakOpponent/track_04.mp3": 91018,
	"./tracks/Earthbound_WeakOpponent/track_05.mp3": 22383,
	"./tracks/Excitebike_Title/track_01.mp3": 66231,
	"./tracks/Excitebike_Title/track_02.mp3": 39999,
	"./tracks/Excitebike_Title/track_03.mp3": 4904,
	"./tracks/Excitebike_Title/track_04.mp3": 35923,
	"./tracks/Excitebike_Title/track_05.mp3": 92495,
	"./tracks/FF1_Battle/track_01.mp3": 89598,
	"./tracks/FF1_Battle/track_02.mp3": 80497,
	"./tracks/FF1_Battle/track_03.mp3": 57387,
	"./tracks/FF1_Battle/track_04.mp3": 37418,
	"./tracks/FF1_Battle/track_05.mp3": 2279,
	"./tracks/FF1_Town/track_01.mp3": 48665,
	"./tracks/FF1_Town/track_02.mp3": 65900,
	"./tracks/FF1_Town/track_03.mp3": 52089,
	"./tracks/FF1_Town/track_04.mp3": 36131,
	"./tracks/FF1_Town/track_05.mp3": 73947,
	"./tracks/FNF_Roses/track_01.mp3": 21829,
	"./tracks/FNF_Roses/track_02.mp3": 80576,
	"./tracks/FNF_Roses/track_03.mp3": 98310,
	"./tracks/FNF_Roses/track_04.mp3": 15928,
	"./tracks/FNF_Roses/track_05.mp3": 99541,
	"./tracks/FZero_BigBlue/track_01.mp3": 55999,
	"./tracks/FZero_BigBlue/track_02.mp3": 85746,
	"./tracks/FZero_BigBlue/track_03.mp3": 65462,
	"./tracks/FZero_BigBlue/track_04.mp3": 22281,
	"./tracks/FZero_BigBlue/track_05.mp3": 46445,
	"./tracks/FZero_MuteCity/track_01.mp3": 5777,
	"./tracks/FZero_MuteCity/track_02.mp3": 42055,
	"./tracks/FZero_MuteCity/track_03.mp3": 17789,
	"./tracks/FZero_MuteCity/track_04.mp3": 3638,
	"./tracks/FZero_MuteCity/track_05.mp3": 7966,
	"./tracks/FZero_PortTown/track_01.mp3": 1483,
	"./tracks/FZero_PortTown/track_02.mp3": 93832,
	"./tracks/FZero_PortTown/track_03.mp3": 28043,
	"./tracks/FZero_PortTown/track_04.mp3": 85694,
	"./tracks/FZero_PortTown/track_05.mp3": 1062,
	"./tracks/Famicom_Startup/track_01.mp3": 41144,
	"./tracks/Famicom_Startup/track_02.mp3": 38325,
	"./tracks/Famicom_Startup/track_03.mp3": 17666,
	"./tracks/Famicom_Startup/track_04.mp3": 40008,
	"./tracks/Famicom_Startup/track_05.mp3": 7686,
	"./tracks/FinalFantasy4_BossFight/track_01.mp3": 99383,
	"./tracks/FinalFantasy4_BossFight/track_02.mp3": 94257,
	"./tracks/FinalFantasy4_BossFight/track_03.mp3": 70315,
	"./tracks/FinalFantasy4_BossFight/track_04.mp3": 41817,
	"./tracks/FinalFantasy4_BossFight/track_05.mp3": 5847,
	"./tracks/FinalFantasy7_Victory/track_01.mp3": 45741,
	"./tracks/FinalFantasy7_Victory/track_02.mp3": 41482,
	"./tracks/FinalFantasy7_Victory/track_03.mp3": 92801,
	"./tracks/FinalFantasy7_Victory/track_04.mp3": 87817,
	"./tracks/FinalFantasy7_Victory/track_05.mp3": 50819,
	"./tracks/FireEmblem_TogetherWeRide/track_01.mp3": 28794,
	"./tracks/FireEmblem_TogetherWeRide/track_02.mp3": 95134,
	"./tracks/FireEmblem_TogetherWeRide/track_03.mp3": 91841,
	"./tracks/FireEmblem_TogetherWeRide/track_04.mp3": 99148,
	"./tracks/FireEmblem_TogetherWeRide/track_05.mp3": 89913,
	"./tracks/Goldeneye007_Watch/track_01.mp3": 45372,
	"./tracks/Goldeneye007_Watch/track_02.mp3": 29596,
	"./tracks/Goldeneye007_Watch/track_03.mp3": 55984,
	"./tracks/Goldeneye007_Watch/track_04.mp3": 85163,
	"./tracks/Goldeneye007_Watch/track_05.mp3": 25097,
	"./tracks/HotlineMiami_MiamiDisco/track_01.mp3": 82642,
	"./tracks/HotlineMiami_MiamiDisco/track_02.mp3": 45904,
	"./tracks/HotlineMiami_MiamiDisco/track_03.mp3": 9668,
	"./tracks/HotlineMiami_MiamiDisco/track_04.mp3": 37473,
	"./tracks/HotlineMiami_MiamiDisco/track_05.mp3": 26509,
	"./tracks/JetSetRadio_ETB/track_01.mp3": 1877,
	"./tracks/JetSetRadio_ETB/track_02.mp3": 69835,
	"./tracks/JetSetRadio_ETB/track_03.mp3": 69362,
	"./tracks/JetSetRadio_ETB/track_04.mp3": 35243,
	"./tracks/JetSetRadio_ETB/track_05.mp3": 4114,
	"./tracks/JetSetRadio_Sneakman/track_01.mp3": 63797,
	"./tracks/JetSetRadio_Sneakman/track_02.mp3": 50503,
	"./tracks/JetSetRadio_Sneakman/track_03.mp3": 18935,
	"./tracks/JetSetRadio_Sneakman/track_04.mp3": 86351,
	"./tracks/JetSetRadio_Sneakman/track_05.mp3": 40571,
	"./tracks/KatamariDamacy_OnTheRocks/track_01.mp3": 34749,
	"./tracks/KatamariDamacy_OnTheRocks/track_02.mp3": 3944,
	"./tracks/KatamariDamacy_OnTheRocks/track_03.mp3": 25283,
	"./tracks/KatamariDamacy_OnTheRocks/track_04.mp3": 29024,
	"./tracks/KatamariDamacy_OnTheRocks/track_05.mp3": 26892,
	"./tracks/KidIcarus_TitleTheme/track_01.mp3": 5867,
	"./tracks/KidIcarus_TitleTheme/track_02.mp3": 8414,
	"./tracks/KidIcarus_TitleTheme/track_03.mp3": 54574,
	"./tracks/KidIcarus_TitleTheme/track_04.mp3": 87683,
	"./tracks/KidIcarus_TitleTheme/track_05.mp3": 43238,
	"./tracks/KidIcarus_Underworld/track_01.mp3": 33739,
	"./tracks/KidIcarus_Underworld/track_02.mp3": 27519,
	"./tracks/KidIcarus_Underworld/track_03.mp3": 32923,
	"./tracks/KidIcarus_Underworld/track_04.mp3": 48506,
	"./tracks/KidIcarus_Underworld/track_05.mp3": 4790,
	"./tracks/KirbyNightmareDreamLand_Forest/track_01.mp3": 65573,
	"./tracks/KirbyNightmareDreamLand_Forest/track_02.mp3": 31783,
	"./tracks/KirbyNightmareDreamLand_Forest/track_03.mp3": 82716,
	"./tracks/KirbyNightmareDreamLand_Forest/track_04.mp3": 88453,
	"./tracks/KirbyNightmareDreamLand_Forest/track_05.mp3": 71203,
	"./tracks/KirbySuperStar_GourmetRace/track_01.mp3": 12524,
	"./tracks/KirbySuperStar_GourmetRace/track_02.mp3": 36836,
	"./tracks/KirbySuperStar_GourmetRace/track_03.mp3": 18092,
	"./tracks/KirbySuperStar_GourmetRace/track_04.mp3": 30468,
	"./tracks/KirbySuperStar_GourmetRace/track_05.mp3": 24911,
	"./tracks/KirbysAdventure_ButterBuilding/track_01.mp3": 49976,
	"./tracks/KirbysAdventure_ButterBuilding/track_02.mp3": 66322,
	"./tracks/KirbysAdventure_ButterBuilding/track_03.mp3": 24424,
	"./tracks/KirbysAdventure_ButterBuilding/track_04.mp3": 95818,
	"./tracks/KirbysAdventure_ButterBuilding/track_05.mp3": 12407,
	"./tracks/KirbysAdventure_VegetableValley/track_01.mp3": 43056,
	"./tracks/KirbysAdventure_VegetableValley/track_02.mp3": 927,
	"./tracks/KirbysAdventure_VegetableValley/track_03.mp3": 95704,
	"./tracks/KirbysAdventure_VegetableValley/track_04.mp3": 50173,
	"./tracks/KirbysAdventure_VegetableValley/track_05.mp3": 6568,
	"./tracks/KirbysDreamLand_Dedede/track_01.mp3": 52129,
	"./tracks/KirbysDreamLand_Dedede/track_02.mp3": 7792,
	"./tracks/KirbysDreamLand_Dedede/track_03.mp3": 52213,
	"./tracks/KirbysDreamLand_Dedede/track_04.mp3": 99745,
	"./tracks/KirbysDreamLand_Dedede/track_05.mp3": 39365,
	"./tracks/KirbysDreamLand_GreenGreens/track_01.mp3": 60568,
	"./tracks/KirbysDreamLand_GreenGreens/track_02.mp3": 14294,
	"./tracks/KirbysDreamLand_GreenGreens/track_03.mp3": 86883,
	"./tracks/KirbysDreamLand_GreenGreens/track_04.mp3": 49849,
	"./tracks/KirbysDreamLand_GreenGreens/track_05.mp3": 4398,
	"./tracks/KirbysDreamLand_TitleTheme/track_01.mp3": 11002,
	"./tracks/KirbysDreamLand_TitleTheme/track_02.mp3": 9357,
	"./tracks/KirbysDreamLand_TitleTheme/track_03.mp3": 81150,
	"./tracks/KirbysDreamLand_TitleTheme/track_04.mp3": 64142,
	"./tracks/KirbysDreamLand_TitleTheme/track_05.mp3": 38208,
	"./tracks/LuigisMansion_EGadd/track_01.mp3": 11267,
	"./tracks/LuigisMansion_EGadd/track_02.mp3": 26088,
	"./tracks/LuigisMansion_EGadd/track_03.mp3": 13649,
	"./tracks/LuigisMansion_EGadd/track_04.mp3": 28647,
	"./tracks/LuigisMansion_EGadd/track_05.mp3": 19053,
	"./tracks/LuigisMansion_GameboyHorror/track_01.mp3": 79983,
	"./tracks/LuigisMansion_GameboyHorror/track_02.mp3": 82549,
	"./tracks/LuigisMansion_GameboyHorror/track_03.mp3": 11873,
	"./tracks/LuigisMansion_GameboyHorror/track_04.mp3": 15538,
	"./tracks/LuigisMansion_GameboyHorror/track_05.mp3": 11249,
	"./tracks/Mario64_BobOmb/track_01.mp3": 58386,
	"./tracks/Mario64_BobOmb/track_02.mp3": 41207,
	"./tracks/Mario64_BobOmb/track_03.mp3": 4644,
	"./tracks/Mario64_BobOmb/track_04.mp3": 24650,
	"./tracks/Mario64_BobOmb/track_05.mp3": 79881,
	"./tracks/Mario64_Credits/track_01.mp3": 6310,
	"./tracks/Mario64_Credits/track_02.mp3": 47129,
	"./tracks/Mario64_Credits/track_03.mp3": 9795,
	"./tracks/Mario64_Credits/track_04.mp3": 28685,
	"./tracks/Mario64_Credits/track_05.mp3": 32392,
	"./tracks/Mario64_Water/track_01.mp3": 26245,
	"./tracks/Mario64_Water/track_02.mp3": 91277,
	"./tracks/Mario64_Water/track_03.mp3": 45759,
	"./tracks/Mario64_Water/track_04.mp3": 98052,
	"./tracks/Mario64_Water/track_05.mp3": 27927,
	"./tracks/MarioKart64_RainbowRoad/track_01.mp3": 64303,
	"./tracks/MarioKart64_RainbowRoad/track_02.mp3": 45906,
	"./tracks/MarioKart64_RainbowRoad/track_03.mp3": 85065,
	"./tracks/MarioKart64_RainbowRoad/track_04.mp3": 40687,
	"./tracks/MarioKart64_RainbowRoad/track_05.mp3": 86875,
	"./tracks/MarioKartDS_Figure8/track_01.mp3": 18179,
	"./tracks/MarioKartDS_Figure8/track_02.mp3": 63457,
	"./tracks/MarioKartDS_Figure8/track_03.mp3": 52028,
	"./tracks/MarioKartDS_Figure8/track_04.mp3": 37589,
	"./tracks/MarioKartDS_Figure8/track_05.mp3": 85597,
	"./tracks/MarioKartDoubleDash_BabyPark/track_01.mp3": 39316,
	"./tracks/MarioKartDoubleDash_BabyPark/track_02.mp3": 93233,
	"./tracks/MarioKartDoubleDash_BabyPark/track_03.mp3": 61359,
	"./tracks/MarioKartDoubleDash_BabyPark/track_04.mp3": 29081,
	"./tracks/MarioKartDoubleDash_BabyPark/track_05.mp3": 11792,
	"./tracks/MarioKartDoubleDash_Menu/track_01.mp3": 50725,
	"./tracks/MarioKartDoubleDash_Menu/track_02.mp3": 17683,
	"./tracks/MarioKartDoubleDash_Menu/track_03.mp3": 63853,
	"./tracks/MarioKartDoubleDash_Menu/track_04.mp3": 68892,
	"./tracks/MarioKartDoubleDash_Menu/track_05.mp3": 40552,
	"./tracks/MarioKartDoubleDash_WaluigiStadium/track_01.mp3": 76114,
	"./tracks/MarioKartDoubleDash_WaluigiStadium/track_02.mp3": 13906,
	"./tracks/MarioKartDoubleDash_WaluigiStadium/track_03.mp3": 5722,
	"./tracks/MarioKartDoubleDash_WaluigiStadium/track_04.mp3": 23434,
	"./tracks/MarioKartDoubleDash_WaluigiStadium/track_05.mp3": 51179,
	"./tracks/MarioKartWii_CoconutMall/track_01.mp3": 62145,
	"./tracks/MarioKartWii_CoconutMall/track_02.mp3": 92381,
	"./tracks/MarioKartWii_CoconutMall/track_03.mp3": 61884,
	"./tracks/MarioKartWii_CoconutMall/track_04.mp3": 28274,
	"./tracks/MarioKartWii_CoconutMall/track_05.mp3": 98141,
	"./tracks/MarioLuigiSuperstarSaga_Battle/track_01.mp3": 244,
	"./tracks/MarioLuigiSuperstarSaga_Battle/track_02.mp3": 58627,
	"./tracks/MarioLuigiSuperstarSaga_Battle/track_03.mp3": 85756,
	"./tracks/MarioLuigiSuperstarSaga_Battle/track_04.mp3": 53885,
	"./tracks/MarioLuigiSuperstarSaga_Battle/track_05.mp3": 45222,
	"./tracks/MarioSunshine_BiancoHills/track_01.mp3": 51350,
	"./tracks/MarioSunshine_BiancoHills/track_02.mp3": 29317,
	"./tracks/MarioSunshine_BiancoHills/track_03.mp3": 43289,
	"./tracks/MarioSunshine_BiancoHills/track_04.mp3": 43546,
	"./tracks/MarioSunshine_BiancoHills/track_05.mp3": 4337,
	"./tracks/MarioSunshine_DelfinoPlaza/track_01.mp3": 63041,
	"./tracks/MarioSunshine_DelfinoPlaza/track_02.mp3": 42054,
	"./tracks/MarioSunshine_DelfinoPlaza/track_03.mp3": 83087,
	"./tracks/MarioSunshine_DelfinoPlaza/track_04.mp3": 96275,
	"./tracks/MarioSunshine_DelfinoPlaza/track_05.mp3": 19779,
	"./tracks/MegaMan2_Wily1/track_01.mp3": 89376,
	"./tracks/MegaMan2_Wily1/track_02.mp3": 36679,
	"./tracks/MegaMan2_Wily1/track_03.mp3": 75448,
	"./tracks/MegaMan2_Wily1/track_04.mp3": 35838,
	"./tracks/MegaMan2_Wily1/track_05.mp3": 58848,
	"./tracks/MegaMan2_WoodMan/track_01.mp3": 12358,
	"./tracks/MegaMan2_WoodMan/track_02.mp3": 88862,
	"./tracks/MegaMan2_WoodMan/track_03.mp3": 93378,
	"./tracks/MegaMan2_WoodMan/track_04.mp3": 448,
	"./tracks/MegaMan2_WoodMan/track_05.mp3": 72943,
	"./tracks/MegaMan3_TitleTheme/track_01.mp3": 77457,
	"./tracks/MegaMan3_TitleTheme/track_02.mp3": 85482,
	"./tracks/MegaMan3_TitleTheme/track_03.mp3": 23245,
	"./tracks/MegaMan3_TitleTheme/track_04.mp3": 81111,
	"./tracks/MegaMan3_TitleTheme/track_05.mp3": 3474,
	"./tracks/MegaMan7_OpeningStage/track_01.mp3": 6735,
	"./tracks/MegaMan7_OpeningStage/track_02.mp3": 79860,
	"./tracks/MegaMan7_OpeningStage/track_03.mp3": 69965,
	"./tracks/MegaMan7_OpeningStage/track_04.mp3": 7201,
	"./tracks/MegaMan7_OpeningStage/track_05.mp3": 85658,
	"./tracks/MegaManX_OpeningStage/track_01.mp3": 68846,
	"./tracks/MegaManX_OpeningStage/track_02.mp3": 86409,
	"./tracks/MegaManX_OpeningStage/track_03.mp3": 5291,
	"./tracks/MegaManX_OpeningStage/track_04.mp3": 14258,
	"./tracks/MegaManX_OpeningStage/track_05.mp3": 35005,
	"./tracks/Metroid_Brinstar/track_01.mp3": 87496,
	"./tracks/Metroid_Brinstar/track_02.mp3": 21004,
	"./tracks/Metroid_Brinstar/track_03.mp3": 15355,
	"./tracks/Metroid_Brinstar/track_04.mp3": 77537,
	"./tracks/Metroid_Brinstar/track_05.mp3": 2577,
	"./tracks/Minecraft_Haggstrom/track_01.mp3": 52868,
	"./tracks/Minecraft_Haggstrom/track_02.mp3": 25917,
	"./tracks/Minecraft_Haggstrom/track_03.mp3": 87727,
	"./tracks/Minecraft_Haggstrom/track_04.mp3": 31204,
	"./tracks/Minecraft_Haggstrom/track_05.mp3": 66298,
	"./tracks/Minecraft_Pigstep/track_01.mp3": 87571,
	"./tracks/Minecraft_Pigstep/track_02.mp3": 17277,
	"./tracks/Minecraft_Pigstep/track_03.mp3": 24763,
	"./tracks/Minecraft_Pigstep/track_04.mp3": 37090,
	"./tracks/Minecraft_Pigstep/track_05.mp3": 45561,
	"./tracks/NinjaGaiden2_Act1Stage1/track_01.mp3": 54224,
	"./tracks/NinjaGaiden2_Act1Stage1/track_02.mp3": 23652,
	"./tracks/NinjaGaiden2_Act1Stage1/track_03.mp3": 62452,
	"./tracks/NinjaGaiden2_Act1Stage1/track_04.mp3": 48229,
	"./tracks/NinjaGaiden2_Act1Stage1/track_05.mp3": 44332,
	"./tracks/NinjaGaiden_Act4Stage2/track_01.mp3": 5459,
	"./tracks/NinjaGaiden_Act4Stage2/track_02.mp3": 93812,
	"./tracks/NinjaGaiden_Act4Stage2/track_03.mp3": 53715,
	"./tracks/NinjaGaiden_Act4Stage2/track_04.mp3": 19631,
	"./tracks/NinjaGaiden_Act4Stage2/track_05.mp3": 30412,
	"./tracks/PaperMarioTTYD_Doopliss/track_01.mp3": 84277,
	"./tracks/PaperMarioTTYD_Doopliss/track_02.mp3": 79632,
	"./tracks/PaperMarioTTYD_Doopliss/track_03.mp3": 94562,
	"./tracks/PaperMarioTTYD_Doopliss/track_04.mp3": 52172,
	"./tracks/PaperMarioTTYD_Doopliss/track_05.mp3": 34726,
	"./tracks/PaperMarioTTYD_MainMenu/track_01.mp3": 33553,
	"./tracks/PaperMarioTTYD_MainMenu/track_02.mp3": 52522,
	"./tracks/PaperMarioTTYD_MainMenu/track_03.mp3": 59144,
	"./tracks/PaperMarioTTYD_MainMenu/track_04.mp3": 74806,
	"./tracks/PaperMarioTTYD_MainMenu/track_05.mp3": 20407,
	"./tracks/PaperMarioTTYD_XNaut/track_01.mp3": 6877,
	"./tracks/PaperMarioTTYD_XNaut/track_02.mp3": 72225,
	"./tracks/PaperMarioTTYD_XNaut/track_03.mp3": 97106,
	"./tracks/PaperMarioTTYD_XNaut/track_04.mp3": 55295,
	"./tracks/PaperMarioTTYD_XNaut/track_05.mp3": 35099,
	"./tracks/Persona3_BattleSouls/track_01.mp3": 15146,
	"./tracks/Persona3_BattleSouls/track_02.mp3": 19456,
	"./tracks/Persona3_BattleSouls/track_03.mp3": 63713,
	"./tracks/Persona3_BattleSouls/track_04.mp3": 16592,
	"./tracks/Persona3_BattleSouls/track_05.mp3": 76336,
	"./tracks/Pictionary_TitleTheme/track_01.mp3": 50594,
	"./tracks/Pictionary_TitleTheme/track_02.mp3": 64466,
	"./tracks/Pictionary_TitleTheme/track_03.mp3": 54060,
	"./tracks/Pictionary_TitleTheme/track_04.mp3": 96693,
	"./tracks/Pictionary_TitleTheme/track_05.mp3": 771,
	"./tracks/PizzaTower_ItsPizzaTime/track_01.mp3": 91440,
	"./tracks/PizzaTower_ItsPizzaTime/track_02.mp3": 3841,
	"./tracks/PizzaTower_ItsPizzaTime/track_03.mp3": 80723,
	"./tracks/PizzaTower_ItsPizzaTime/track_04.mp3": 87339,
	"./tracks/PizzaTower_ItsPizzaTime/track_05.mp3": 85867,
	"./tracks/PokemonGSC_Azalea/track_01.mp3": 26556,
	"./tracks/PokemonGSC_Azalea/track_02.mp3": 55367,
	"./tracks/PokemonGSC_Azalea/track_03.mp3": 87649,
	"./tracks/PokemonGSC_Azalea/track_04.mp3": 28754,
	"./tracks/PokemonGSC_Azalea/track_05.mp3": 45837,
	"./tracks/PokemonGSC_GameCorner/track_01.mp3": 70586,
	"./tracks/PokemonGSC_GameCorner/track_02.mp3": 66364,
	"./tracks/PokemonGSC_GameCorner/track_03.mp3": 51865,
	"./tracks/PokemonGSC_GameCorner/track_04.mp3": 77041,
	"./tracks/PokemonGSC_GameCorner/track_05.mp3": 76268,
	"./tracks/PokemonGSC_NationalPark/track_01.mp3": 34153,
	"./tracks/PokemonGSC_NationalPark/track_02.mp3": 34769,
	"./tracks/PokemonGSC_NationalPark/track_03.mp3": 59536,
	"./tracks/PokemonGSC_NationalPark/track_04.mp3": 26274,
	"./tracks/PokemonGSC_NationalPark/track_05.mp3": 23145,
	"./tracks/PokemonGSC_PokemonBattle/track_01.mp3": 5030,
	"./tracks/PokemonGSC_PokemonBattle/track_02.mp3": 49310,
	"./tracks/PokemonGSC_PokemonBattle/track_03.mp3": 82849,
	"./tracks/PokemonGSC_PokemonBattle/track_04.mp3": 360,
	"./tracks/PokemonGSC_PokemonBattle/track_05.mp3": 58963,
	"./tracks/PokemonRGBY_LavenderTown/track_01.mp3": 57650,
	"./tracks/PokemonRGBY_LavenderTown/track_02.mp3": 91084,
	"./tracks/PokemonRGBY_LavenderTown/track_03.mp3": 93334,
	"./tracks/PokemonRGBY_LavenderTown/track_04.mp3": 71853,
	"./tracks/PokemonRGBY_LavenderTown/track_05.mp3": 69894,
	"./tracks/PokemonRGBY_PokemonBattle/track_01.mp3": 55743,
	"./tracks/PokemonRGBY_PokemonBattle/track_02.mp3": 59787,
	"./tracks/PokemonRGBY_PokemonBattle/track_03.mp3": 3505,
	"./tracks/PokemonRGBY_PokemonBattle/track_04.mp3": 54037,
	"./tracks/PokemonRGBY_PokemonBattle/track_05.mp3": 9065,
	"./tracks/PokemonRGBY_Route1/track_01.mp3": 59720,
	"./tracks/PokemonRGBY_Route1/track_02.mp3": 60697,
	"./tracks/PokemonRGBY_Route1/track_03.mp3": 67446,
	"./tracks/PokemonRGBY_Route1/track_04.mp3": 2213,
	"./tracks/PokemonRGBY_Route1/track_05.mp3": 2123,
	"./tracks/PokemonRGBY_Route3/track_01.mp3": 27329,
	"./tracks/PokemonRGBY_Route3/track_02.mp3": 26257,
	"./tracks/PokemonRGBY_Route3/track_03.mp3": 22208,
	"./tracks/PokemonRGBY_Route3/track_04.mp3": 51654,
	"./tracks/PokemonRGBY_Route3/track_05.mp3": 62047,
	"./tracks/PokemonRGBY_VeridianForest/track_01.mp3": 46001,
	"./tracks/PokemonRGBY_VeridianForest/track_02.mp3": 51514,
	"./tracks/PokemonRGBY_VeridianForest/track_03.mp3": 40673,
	"./tracks/PokemonRGBY_VeridianForest/track_04.mp3": 56262,
	"./tracks/PokemonRGBY_VeridianForest/track_05.mp3": 36623,
	"./tracks/Portal_StillAlive/track_01.mp3": 15844,
	"./tracks/Portal_StillAlive/track_02.mp3": 84369,
	"./tracks/Portal_StillAlive/track_03.mp3": 84086,
	"./tracks/Portal_StillAlive/track_04.mp3": 65442,
	"./tracks/Portal_StillAlive/track_05.mp3": 23338,
	"./tracks/PunchOut_Fight/track_01.mp3": 99887,
	"./tracks/PunchOut_Fight/track_02.mp3": 77830,
	"./tracks/PunchOut_Fight/track_03.mp3": 36861,
	"./tracks/PunchOut_Fight/track_04.mp3": 88633,
	"./tracks/PunchOut_Fight/track_05.mp3": 65582,
	"./tracks/RhythmHeavenFever_Ringside/track_01.mp3": 50038,
	"./tracks/RhythmHeavenFever_Ringside/track_02.mp3": 6357,
	"./tracks/RhythmHeavenFever_Ringside/track_03.mp3": 18180,
	"./tracks/RhythmHeavenFever_Ringside/track_04.mp3": 79701,
	"./tracks/RhythmHeavenFever_Ringside/track_05.mp3": 73542,
	"./tracks/RhythmHeaven_Practice/track_01.mp3": 88279,
	"./tracks/RhythmHeaven_Practice/track_02.mp3": 93251,
	"./tracks/RhythmHeaven_Practice/track_03.mp3": 90813,
	"./tracks/RhythmHeaven_Practice/track_04.mp3": 10929,
	"./tracks/RhythmHeaven_Practice/track_05.mp3": 79552,
	"./tracks/RhythmTengoku_Ninja/track_01.mp3": 45112,
	"./tracks/RhythmTengoku_Ninja/track_02.mp3": 78481,
	"./tracks/RhythmTengoku_Ninja/track_03.mp3": 7655,
	"./tracks/RhythmTengoku_Ninja/track_04.mp3": 66299,
	"./tracks/RhythmTengoku_Ninja/track_05.mp3": 7653,
	"./tracks/ShovelKnight_StrikeTheEarth/track_01.mp3": 40854,
	"./tracks/ShovelKnight_StrikeTheEarth/track_02.mp3": 90501,
	"./tracks/ShovelKnight_StrikeTheEarth/track_03.mp3": 21256,
	"./tracks/ShovelKnight_StrikeTheEarth/track_04.mp3": 6297,
	"./tracks/ShovelKnight_StrikeTheEarth/track_05.mp3": 33060,
	"./tracks/SilverSurfer_Level1/track_01.mp3": 78506,
	"./tracks/SilverSurfer_Level1/track_02.mp3": 50595,
	"./tracks/SilverSurfer_Level1/track_03.mp3": 99743,
	"./tracks/SilverSurfer_Level1/track_04.mp3": 54907,
	"./tracks/SilverSurfer_Level1/track_05.mp3": 69132,
	"./tracks/SilverSurfer_TitleTheme/track_01.mp3": 78495,
	"./tracks/SilverSurfer_TitleTheme/track_02.mp3": 19798,
	"./tracks/SilverSurfer_TitleTheme/track_03.mp3": 13101,
	"./tracks/SilverSurfer_TitleTheme/track_04.mp3": 23297,
	"./tracks/SilverSurfer_TitleTheme/track_05.mp3": 13996,
	"./tracks/SkateOrDie2_TitleTheme/track_01.mp3": 60999,
	"./tracks/SkateOrDie2_TitleTheme/track_02.mp3": 38593,
	"./tracks/SkateOrDie2_TitleTheme/track_03.mp3": 65609,
	"./tracks/SkateOrDie2_TitleTheme/track_04.mp3": 14249,
	"./tracks/SkateOrDie2_TitleTheme/track_05.mp3": 63686,
	"./tracks/SmashUltimate_Lifelight/track_01.mp3": 49092,
	"./tracks/SmashUltimate_Lifelight/track_02.mp3": 51846,
	"./tracks/SmashUltimate_Lifelight/track_03.mp3": 24716,
	"./tracks/SmashUltimate_Lifelight/track_04.mp3": 25176,
	"./tracks/SmashUltimate_Lifelight/track_05.mp3": 9922,
	"./tracks/Sonic1_GreenHill/track_01.mp3": 57118,
	"./tracks/Sonic1_GreenHill/track_02.mp3": 27361,
	"./tracks/Sonic1_GreenHill/track_03.mp3": 94302,
	"./tracks/Sonic1_GreenHill/track_04.mp3": 58287,
	"./tracks/Sonic1_GreenHill/track_05.mp3": 53871,
	"./tracks/Sonic1_MarbleZone/track_01.mp3": 46981,
	"./tracks/Sonic1_MarbleZone/track_02.mp3": 46936,
	"./tracks/Sonic1_MarbleZone/track_03.mp3": 20610,
	"./tracks/Sonic1_MarbleZone/track_04.mp3": 328,
	"./tracks/Sonic1_MarbleZone/track_05.mp3": 47037,
	"./tracks/Sonic2_ChemicalPlantZone/track_01.mp3": 52973,
	"./tracks/Sonic2_ChemicalPlantZone/track_02.mp3": 26677,
	"./tracks/Sonic2_ChemicalPlantZone/track_03.mp3": 56620,
	"./tracks/Sonic2_ChemicalPlantZone/track_04.mp3": 29769,
	"./tracks/Sonic2_ChemicalPlantZone/track_05.mp3": 36642,
	"./tracks/Sonic3_IceCapZone/track_01.mp3": 4327,
	"./tracks/Sonic3_IceCapZone/track_02.mp3": 10717,
	"./tracks/Sonic3_IceCapZone/track_03.mp3": 62127,
	"./tracks/Sonic3_IceCapZone/track_04.mp3": 22464,
	"./tracks/Sonic3_IceCapZone/track_05.mp3": 64939,
	"./tracks/SonicAdvance2_IceParadise1/track_01.mp3": 11276,
	"./tracks/SonicAdvance2_IceParadise1/track_02.mp3": 61793,
	"./tracks/SonicAdvance2_IceParadise1/track_03.mp3": 55545,
	"./tracks/SonicAdvance2_IceParadise1/track_04.mp3": 27783,
	"./tracks/SonicAdvance2_IceParadise1/track_05.mp3": 22712,
	"./tracks/SonicAdvance_SecretBase1/track_01.mp3": 32697,
	"./tracks/SonicAdvance_SecretBase1/track_02.mp3": 78748,
	"./tracks/SonicAdvance_SecretBase1/track_03.mp3": 27726,
	"./tracks/SonicAdvance_SecretBase1/track_04.mp3": 88349,
	"./tracks/SonicAdvance_SecretBase1/track_05.mp3": 61168,
	"./tracks/SonicCD_SonicBoom/track_01.mp3": 95548,
	"./tracks/SonicCD_SonicBoom/track_02.mp3": 98954,
	"./tracks/SonicCD_SonicBoom/track_03.mp3": 62325,
	"./tracks/SonicCD_SonicBoom/track_04.mp3": 75763,
	"./tracks/SonicCD_SonicBoom/track_05.mp3": 81712,
	"./tracks/SonicKnuckles_FlyingBatteryZone/track_01.mp3": 17839,
	"./tracks/SonicKnuckles_FlyingBatteryZone/track_02.mp3": 65694,
	"./tracks/SonicKnuckles_FlyingBatteryZone/track_03.mp3": 68651,
	"./tracks/SonicKnuckles_FlyingBatteryZone/track_04.mp3": 13633,
	"./tracks/SonicKnuckles_FlyingBatteryZone/track_05.mp3": 1634,
	"./tracks/SonicMania_Studiopolis/track_01.mp3": 11902,
	"./tracks/SonicMania_Studiopolis/track_02.mp3": 22566,
	"./tracks/SonicMania_Studiopolis/track_03.mp3": 42145,
	"./tracks/SonicMania_Studiopolis/track_04.mp3": 38871,
	"./tracks/SonicMania_Studiopolis/track_05.mp3": 27735,
	"./tracks/SonicR_Resort/track_01.mp3": 53974,
	"./tracks/SonicR_Resort/track_02.mp3": 2135,
	"./tracks/SonicR_Resort/track_03.mp3": 30733,
	"./tracks/SonicR_Resort/track_04.mp3": 81592,
	"./tracks/SonicR_Resort/track_05.mp3": 95346,
	"./tracks/Splatoon_CalamariInkantation/track_01.mp3": 94636,
	"./tracks/Splatoon_CalamariInkantation/track_02.mp3": 16527,
	"./tracks/Splatoon_CalamariInkantation/track_03.mp3": 5673,
	"./tracks/Splatoon_CalamariInkantation/track_04.mp3": 19895,
	"./tracks/Splatoon_CalamariInkantation/track_05.mp3": 79582,
	"./tracks/Splatoon_Splattack/track_01.mp3": 89409,
	"./tracks/Splatoon_Splattack/track_02.mp3": 75633,
	"./tracks/Splatoon_Splattack/track_03.mp3": 38294,
	"./tracks/Splatoon_Splattack/track_04.mp3": 59704,
	"./tracks/Splatoon_Splattack/track_05.mp3": 53628,
	"./tracks/StarFox_Corneria/track_01.mp3": 85148,
	"./tracks/StarFox_Corneria/track_02.mp3": 60316,
	"./tracks/StarFox_Corneria/track_03.mp3": 62133,
	"./tracks/StarFox_Corneria/track_04.mp3": 68912,
	"./tracks/StarFox_Corneria/track_05.mp3": 10185,
	"./tracks/StarFox_Fortuna/track_01.mp3": 80794,
	"./tracks/StarFox_Fortuna/track_02.mp3": 17594,
	"./tracks/StarFox_Fortuna/track_03.mp3": 1964,
	"./tracks/StarFox_Fortuna/track_04.mp3": 82189,
	"./tracks/StarFox_Fortuna/track_05.mp3": 1945,
	"./tracks/StarFox_Macbeth/track_01.mp3": 2977,
	"./tracks/StarFox_Macbeth/track_02.mp3": 41546,
	"./tracks/StarFox_Macbeth/track_03.mp3": 87014,
	"./tracks/StarFox_Macbeth/track_04.mp3": 90379,
	"./tracks/StarFox_Macbeth/track_05.mp3": 13127,
	"./tracks/StreetFighter2_Guile/track_01.mp3": 83729,
	"./tracks/StreetFighter2_Guile/track_02.mp3": 20397,
	"./tracks/StreetFighter2_Guile/track_03.mp3": 24627,
	"./tracks/StreetFighter2_Guile/track_04.mp3": 41013,
	"./tracks/StreetFighter2_Guile/track_05.mp3": 60093,
	"./tracks/StreetFighter2_RyusTheme/track_01.mp3": 72447,
	"./tracks/StreetFighter2_RyusTheme/track_02.mp3": 70771,
	"./tracks/StreetFighter2_RyusTheme/track_03.mp3": 87562,
	"./tracks/StreetFighter2_RyusTheme/track_04.mp3": 89954,
	"./tracks/StreetFighter2_RyusTheme/track_05.mp3": 69347,
	"./tracks/SuperMarioBros2_CharacterSelect/track_01.mp3": 71350,
	"./tracks/SuperMarioBros2_CharacterSelect/track_02.mp3": 48645,
	"./tracks/SuperMarioBros2_CharacterSelect/track_03.mp3": 17373,
	"./tracks/SuperMarioBros2_CharacterSelect/track_04.mp3": 89742,
	"./tracks/SuperMarioBros2_CharacterSelect/track_05.mp3": 88053,
	"./tracks/SuperMarioBros2_Overworld/track_01.mp3": 464,
	"./tracks/SuperMarioBros2_Overworld/track_02.mp3": 22557,
	"./tracks/SuperMarioBros2_Overworld/track_03.mp3": 41872,
	"./tracks/SuperMarioBros2_Overworld/track_04.mp3": 11888,
	"./tracks/SuperMarioBros2_Overworld/track_05.mp3": 11745,
	"./tracks/SuperMarioBros3_Airship/track_01.mp3": 42413,
	"./tracks/SuperMarioBros3_Airship/track_02.mp3": 84923,
	"./tracks/SuperMarioBros3_Airship/track_03.mp3": 23192,
	"./tracks/SuperMarioBros3_Airship/track_04.mp3": 29329,
	"./tracks/SuperMarioBros3_Airship/track_05.mp3": 73156,
	"./tracks/SuperMarioBros3_KoopaKids/track_01.mp3": 22675,
	"./tracks/SuperMarioBros3_KoopaKids/track_02.mp3": 24955,
	"./tracks/SuperMarioBros3_KoopaKids/track_03.mp3": 83590,
	"./tracks/SuperMarioBros3_KoopaKids/track_04.mp3": 66282,
	"./tracks/SuperMarioBros3_KoopaKids/track_05.mp3": 69667,
	"./tracks/SuperMarioBros3_Overworld1/track_01.mp3": 53148,
	"./tracks/SuperMarioBros3_Overworld1/track_02.mp3": 68405,
	"./tracks/SuperMarioBros3_Overworld1/track_03.mp3": 90343,
	"./tracks/SuperMarioBros3_Overworld1/track_04.mp3": 64668,
	"./tracks/SuperMarioBros3_Overworld1/track_05.mp3": 53020,
	"./tracks/SuperMarioBros3_Overworld2/track_01.mp3": 88770,
	"./tracks/SuperMarioBros3_Overworld2/track_02.mp3": 86553,
	"./tracks/SuperMarioBros3_Overworld2/track_03.mp3": 2770,
	"./tracks/SuperMarioBros3_Overworld2/track_04.mp3": 64577,
	"./tracks/SuperMarioBros3_Overworld2/track_05.mp3": 35021,
	"./tracks/SuperMarioBros3_Underground/track_01.mp3": 97197,
	"./tracks/SuperMarioBros3_Underground/track_02.mp3": 76882,
	"./tracks/SuperMarioBros3_Underground/track_03.mp3": 78222,
	"./tracks/SuperMarioBros3_Underground/track_04.mp3": 30791,
	"./tracks/SuperMarioBros3_Underground/track_05.mp3": 29638,
	"./tracks/SuperMarioBros3_Underwater/track_01.mp3": 59718,
	"./tracks/SuperMarioBros3_Underwater/track_02.mp3": 1608,
	"./tracks/SuperMarioBros3_Underwater/track_03.mp3": 47724,
	"./tracks/SuperMarioBros3_Underwater/track_04.mp3": 6394,
	"./tracks/SuperMarioBros3_Underwater/track_05.mp3": 41483,
	"./tracks/SuperMarioBros_Overworld/track_01.mp3": 29255,
	"./tracks/SuperMarioBros_Overworld/track_02.mp3": 59727,
	"./tracks/SuperMarioBros_Overworld/track_03.mp3": 4583,
	"./tracks/SuperMarioBros_Overworld/track_04.mp3": 47434,
	"./tracks/SuperMarioBros_Overworld/track_05.mp3": 80878,
	"./tracks/SuperMarioBros_Underwater/track_01.mp3": 88549,
	"./tracks/SuperMarioBros_Underwater/track_02.mp3": 14700,
	"./tracks/SuperMarioBros_Underwater/track_03.mp3": 19918,
	"./tracks/SuperMarioBros_Underwater/track_04.mp3": 5572,
	"./tracks/SuperMarioBros_Underwater/track_05.mp3": 79077,
	"./tracks/SuperMarioKart_MarioCircuit/track_01.mp3": 84985,
	"./tracks/SuperMarioKart_MarioCircuit/track_02.mp3": 45706,
	"./tracks/SuperMarioKart_MarioCircuit/track_03.mp3": 28943,
	"./tracks/SuperMarioKart_MarioCircuit/track_04.mp3": 92059,
	"./tracks/SuperMarioKart_MarioCircuit/track_05.mp3": 82251,
	"./tracks/SuperMarioLand2_Overworld/track_01.mp3": 45788,
	"./tracks/SuperMarioLand2_Overworld/track_02.mp3": 78020,
	"./tracks/SuperMarioLand2_Overworld/track_03.mp3": 609,
	"./tracks/SuperMarioLand2_Overworld/track_04.mp3": 38738,
	"./tracks/SuperMarioLand2_Overworld/track_05.mp3": 14836,
	"./tracks/SuperMarioLand2_SpaceZone/track_01.mp3": 24362,
	"./tracks/SuperMarioLand2_SpaceZone/track_02.mp3": 19515,
	"./tracks/SuperMarioLand2_SpaceZone/track_03.mp3": 16174,
	"./tracks/SuperMarioLand2_SpaceZone/track_04.mp3": 97441,
	"./tracks/SuperMarioLand2_SpaceZone/track_05.mp3": 99937,
	"./tracks/SuperMarioLand_World1/track_01.mp3": 8407,
	"./tracks/SuperMarioLand_World1/track_02.mp3": 61538,
	"./tracks/SuperMarioLand_World1/track_03.mp3": 52233,
	"./tracks/SuperMarioLand_World1/track_04.mp3": 83908,
	"./tracks/SuperMarioLand_World1/track_05.mp3": 91420,
	"./tracks/SuperMarioLand_World2/track_01.mp3": 16023,
	"./tracks/SuperMarioLand_World2/track_02.mp3": 38223,
	"./tracks/SuperMarioLand_World2/track_03.mp3": 34290,
	"./tracks/SuperMarioLand_World2/track_04.mp3": 943,
	"./tracks/SuperMarioLand_World2/track_05.mp3": 38645,
	"./tracks/SuperMarioRPG_ForestMaze/track_01.mp3": 90522,
	"./tracks/SuperMarioRPG_ForestMaze/track_02.mp3": 52197,
	"./tracks/SuperMarioRPG_ForestMaze/track_03.mp3": 65672,
	"./tracks/SuperMarioRPG_ForestMaze/track_04.mp3": 84781,
	"./tracks/SuperMarioRPG_ForestMaze/track_05.mp3": 51869,
	"./tracks/SuperMarioWorld_Bowser/track_01.mp3": 84764,
	"./tracks/SuperMarioWorld_Bowser/track_02.mp3": 24990,
	"./tracks/SuperMarioWorld_Bowser/track_03.mp3": 54101,
	"./tracks/SuperMarioWorld_Bowser/track_04.mp3": 95347,
	"./tracks/SuperMarioWorld_Bowser/track_05.mp3": 97843,
	"./tracks/SuperMarioWorld_EndingCredits/track_01.mp3": 71758,
	"./tracks/SuperMarioWorld_EndingCredits/track_02.mp3": 30966,
	"./tracks/SuperMarioWorld_EndingCredits/track_03.mp3": 72364,
	"./tracks/SuperMarioWorld_EndingCredits/track_04.mp3": 5443,
	"./tracks/SuperMarioWorld_EndingCredits/track_05.mp3": 28067,
	"./tracks/SuperMarioWorld_Overworld/track_01.mp3": 45942,
	"./tracks/SuperMarioWorld_Overworld/track_02.mp3": 66345,
	"./tracks/SuperMarioWorld_Overworld/track_03.mp3": 65005,
	"./tracks/SuperMarioWorld_Overworld/track_04.mp3": 34345,
	"./tracks/SuperMarioWorld_Overworld/track_05.mp3": 12603,
	"./tracks/SuperMarioWorld_Title/track_01.mp3": 90891,
	"./tracks/SuperMarioWorld_Title/track_02.mp3": 14088,
	"./tracks/SuperMarioWorld_Title/track_03.mp3": 98338,
	"./tracks/SuperMarioWorld_Title/track_04.mp3": 79347,
	"./tracks/SuperMarioWorld_Title/track_05.mp3": 91678,
	"./tracks/SuperMarioWorld_Underground/track_01.mp3": 45002,
	"./tracks/SuperMarioWorld_Underground/track_02.mp3": 50472,
	"./tracks/SuperMarioWorld_Underground/track_03.mp3": 98314,
	"./tracks/SuperMarioWorld_Underground/track_04.mp3": 67543,
	"./tracks/SuperMarioWorld_Underground/track_05.mp3": 32484,
	"./tracks/SuperMarioWorld_Underwater/track_01.mp3": 51703,
	"./tracks/SuperMarioWorld_Underwater/track_02.mp3": 4033,
	"./tracks/SuperMarioWorld_Underwater/track_03.mp3": 35022,
	"./tracks/SuperMarioWorld_Underwater/track_04.mp3": 53371,
	"./tracks/SuperMarioWorld_Underwater/track_05.mp3": 42385,
	"./tracks/TBOI_Sacrificial/track_01.mp3": 70345,
	"./tracks/TBOI_Sacrificial/track_02.mp3": 66942,
	"./tracks/TBOI_Sacrificial/track_03.mp3": 65957,
	"./tracks/TBOI_Sacrificial/track_04.mp3": 97644,
	"./tracks/TBOI_Sacrificial/track_05.mp3": 62043,
	"./tracks/TMNT_Boss/track_01.mp3": 77427,
	"./tracks/TMNT_Boss/track_02.mp3": 63731,
	"./tracks/TMNT_Boss/track_03.mp3": 9557,
	"./tracks/TMNT_Boss/track_04.mp3": 89812,
	"./tracks/TMNT_Boss/track_05.mp3": 28136,
	"./tracks/TeamFortress2_Theme/track_01.mp3": 32931,
	"./tracks/TeamFortress2_Theme/track_02.mp3": 94518,
	"./tracks/TeamFortress2_Theme/track_03.mp3": 85749,
	"./tracks/TeamFortress2_Theme/track_04.mp3": 6820,
	"./tracks/TeamFortress2_Theme/track_05.mp3": 23533,
	"./tracks/Terraria_Overworld/track_01.mp3": 20714,
	"./tracks/Terraria_Overworld/track_02.mp3": 36211,
	"./tracks/Terraria_Overworld/track_03.mp3": 56771,
	"./tracks/Terraria_Overworld/track_04.mp3": 62168,
	"./tracks/Terraria_Overworld/track_05.mp3": 79059,
	"./tracks/Tetris_A/track_01.mp3": 61677,
	"./tracks/Tetris_A/track_02.mp3": 7763,
	"./tracks/Tetris_A/track_03.mp3": 79567,
	"./tracks/Tetris_A/track_04.mp3": 26256,
	"./tracks/Tetris_A/track_05.mp3": 31529,
	"./tracks/Tetris_B/track_01.mp3": 43530,
	"./tracks/Tetris_B/track_02.mp3": 52335,
	"./tracks/Tetris_B/track_03.mp3": 77225,
	"./tracks/Tetris_B/track_04.mp3": 71974,
	"./tracks/Tetris_B/track_05.mp3": 52762,
	"./tracks/TomodachiLife_MapDay/track_01.mp3": 72640,
	"./tracks/TomodachiLife_MapDay/track_02.mp3": 13859,
	"./tracks/TomodachiLife_MapDay/track_03.mp3": 11713,
	"./tracks/TomodachiLife_MapDay/track_04.mp3": 49181,
	"./tracks/TomodachiLife_MapDay/track_05.mp3": 78213,
	"./tracks/Touhou4_BadApple/track_01.mp3": 65084,
	"./tracks/Touhou4_BadApple/track_02.mp3": 14407,
	"./tracks/Touhou4_BadApple/track_03.mp3": 82922,
	"./tracks/Touhou4_BadApple/track_04.mp3": 46188,
	"./tracks/Touhou4_BadApple/track_05.mp3": 40003,
	"./tracks/Undertale_ASGORE/track_01.mp3": 97424,
	"./tracks/Undertale_ASGORE/track_02.mp3": 48639,
	"./tracks/Undertale_ASGORE/track_03.mp3": 95635,
	"./tracks/Undertale_ASGORE/track_04.mp3": 16368,
	"./tracks/Undertale_ASGORE/track_05.mp3": 40,
	"./tracks/Undertale_AnotherMedium/track_01.mp3": 74515,
	"./tracks/Undertale_AnotherMedium/track_02.mp3": 1284,
	"./tracks/Undertale_AnotherMedium/track_03.mp3": 61908,
	"./tracks/Undertale_AnotherMedium/track_04.mp3": 47385,
	"./tracks/Undertale_AnotherMedium/track_05.mp3": 46245,
	"./tracks/Undertale_Bonetrousle/track_01.mp3": 43294,
	"./tracks/Undertale_Bonetrousle/track_02.mp3": 11785,
	"./tracks/Undertale_Bonetrousle/track_03.mp3": 50399,
	"./tracks/Undertale_Bonetrousle/track_04.mp3": 17767,
	"./tracks/Undertale_Bonetrousle/track_05.mp3": 15959,
	"./tracks/Undertale_CORE/track_01.mp3": 69760,
	"./tracks/Undertale_CORE/track_02.mp3": 7282,
	"./tracks/Undertale_CORE/track_03.mp3": 81271,
	"./tracks/Undertale_CORE/track_04.mp3": 87509,
	"./tracks/Undertale_CORE/track_05.mp3": 97979,
	"./tracks/Undertale_EnemyApproaching/track_01.mp3": 63550,
	"./tracks/Undertale_EnemyApproaching/track_02.mp3": 67094,
	"./tracks/Undertale_EnemyApproaching/track_03.mp3": 63557,
	"./tracks/Undertale_EnemyApproaching/track_04.mp3": 75526,
	"./tracks/Undertale_EnemyApproaching/track_05.mp3": 57245,
	"./tracks/Undertale_Megalovania/track_01.mp3": 83902,
	"./tracks/Undertale_Megalovania/track_02.mp3": 97260,
	"./tracks/Undertale_Megalovania/track_03.mp3": 97392,
	"./tracks/Undertale_Megalovania/track_04.mp3": 37176,
	"./tracks/Undertale_Megalovania/track_05.mp3": 92167,
	"./tracks/Undertale_sans/track_01.mp3": 26529,
	"./tracks/Undertale_sans/track_02.mp3": 86805,
	"./tracks/Undertale_sans/track_03.mp3": 9818,
	"./tracks/Undertale_sans/track_04.mp3": 50912,
	"./tracks/Undertale_sans/track_05.mp3": 82085,
	"./tracks/YoshisIsland_Athletic/track_01.mp3": 41505,
	"./tracks/YoshisIsland_Athletic/track_02.mp3": 21618,
	"./tracks/YoshisIsland_Athletic/track_03.mp3": 23847,
	"./tracks/YoshisIsland_Athletic/track_04.mp3": 86626,
	"./tracks/YoshisIsland_Athletic/track_05.mp3": 68645,
	"./tracks/YoshisIsland_FlowerGarden/track_01.mp3": 22395,
	"./tracks/YoshisIsland_FlowerGarden/track_02.mp3": 53614,
	"./tracks/YoshisIsland_FlowerGarden/track_03.mp3": 97396,
	"./tracks/YoshisIsland_FlowerGarden/track_04.mp3": 54530,
	"./tracks/YoshisIsland_FlowerGarden/track_05.mp3": 45076,
	"./tracks/YoshisIsland_Map/track_01.mp3": 36892,
	"./tracks/YoshisIsland_Map/track_02.mp3": 32168,
	"./tracks/YoshisIsland_Map/track_03.mp3": 90181,
	"./tracks/YoshisIsland_Map/track_04.mp3": 95645,
	"./tracks/YoshisIsland_Map/track_05.mp3": 53266,
	"./tracks/YoshisIsland_Underground/track_01.mp3": 80007,
	"./tracks/YoshisIsland_Underground/track_02.mp3": 47405,
	"./tracks/YoshisIsland_Underground/track_03.mp3": 92501,
	"./tracks/YoshisIsland_Underground/track_04.mp3": 80417,
	"./tracks/YoshisIsland_Underground/track_05.mp3": 82599,
	"./tracks/Zelda1_Labyrinth/track_01.mp3": 3424,
	"./tracks/Zelda1_Labyrinth/track_02.mp3": 29539,
	"./tracks/Zelda1_Labyrinth/track_03.mp3": 60689,
	"./tracks/Zelda1_Labyrinth/track_04.mp3": 20223,
	"./tracks/Zelda1_Labyrinth/track_05.mp3": 36921,
	"./tracks/Zelda1_Overworld/track_01.mp3": 98170,
	"./tracks/Zelda1_Overworld/track_02.mp3": 50015,
	"./tracks/Zelda1_Overworld/track_03.mp3": 70889,
	"./tracks/Zelda1_Overworld/track_04.mp3": 96082,
	"./tracks/Zelda1_Overworld/track_05.mp3": 71357,
	"./tracks/Zelda1_Title/track_01.mp3": 62434,
	"./tracks/Zelda1_Title/track_02.mp3": 83058,
	"./tracks/Zelda1_Title/track_03.mp3": 87273,
	"./tracks/Zelda1_Title/track_04.mp3": 29045,
	"./tracks/Zelda1_Title/track_05.mp3": 13422,
	"./tracks/ZeldaLinkToThePast_DarkWorld/track_01.mp3": 41925,
	"./tracks/ZeldaLinkToThePast_DarkWorld/track_02.mp3": 34483,
	"./tracks/ZeldaLinkToThePast_DarkWorld/track_03.mp3": 13645,
	"./tracks/ZeldaLinkToThePast_DarkWorld/track_04.mp3": 42537,
	"./tracks/ZeldaLinkToThePast_DarkWorld/track_05.mp3": 88440,
	"./tracks/ZeldaLinkToThePast_Fairy/track_01.mp3": 49610,
	"./tracks/ZeldaLinkToThePast_Fairy/track_02.mp3": 33030,
	"./tracks/ZeldaLinkToThePast_Fairy/track_03.mp3": 14421,
	"./tracks/ZeldaLinkToThePast_Fairy/track_04.mp3": 86969,
	"./tracks/ZeldaLinkToThePast_Fairy/track_05.mp3": 525,
	"./tracks/ZeldaLinksAwakening_TalTalHeights/track_01.mp3": 67342,
	"./tracks/ZeldaLinksAwakening_TalTalHeights/track_02.mp3": 5020,
	"./tracks/ZeldaLinksAwakening_TalTalHeights/track_03.mp3": 32194,
	"./tracks/ZeldaLinksAwakening_TalTalHeights/track_04.mp3": 85667,
	"./tracks/ZeldaLinksAwakening_TalTalHeights/track_05.mp3": 35111,
	"./tracks/ZeldaMajorasMask_ClockTown1/track_01.mp3": 32783,
	"./tracks/ZeldaMajorasMask_ClockTown1/track_02.mp3": 57039,
	"./tracks/ZeldaMajorasMask_ClockTown1/track_03.mp3": 53839,
	"./tracks/ZeldaMajorasMask_ClockTown1/track_04.mp3": 36526,
	"./tracks/ZeldaMajorasMask_ClockTown1/track_05.mp3": 79110,
	"./tracks/ZeldaMinishCap_MinishVillage/track_01.mp3": 45530,
	"./tracks/ZeldaMinishCap_MinishVillage/track_02.mp3": 9653,
	"./tracks/ZeldaMinishCap_MinishVillage/track_03.mp3": 25785,
	"./tracks/ZeldaMinishCap_MinishVillage/track_04.mp3": 50419,
	"./tracks/ZeldaMinishCap_MinishVillage/track_05.mp3": 1735,
	"./tracks/ZeldaOcarina_LonLonRanch/track_01.mp3": 61955,
	"./tracks/ZeldaOcarina_LonLonRanch/track_02.mp3": 99645,
	"./tracks/ZeldaOcarina_LonLonRanch/track_03.mp3": 99586,
	"./tracks/ZeldaOcarina_LonLonRanch/track_04.mp3": 31018,
	"./tracks/ZeldaOcarina_LonLonRanch/track_05.mp3": 12953,
	"./tracks/ZeldaOcarina_Zora/track_01.mp3": 20828,
	"./tracks/ZeldaOcarina_Zora/track_02.mp3": 78312,
	"./tracks/ZeldaOcarina_Zora/track_03.mp3": 31862,
	"./tracks/ZeldaOcarina_Zora/track_04.mp3": 78649,
	"./tracks/ZeldaOcarina_Zora/track_05.mp3": 63277,
	"./tracks/ZeldaWindWaker_DragonRoost/track_01.mp3": 38257,
	"./tracks/ZeldaWindWaker_DragonRoost/track_02.mp3": 95098,
	"./tracks/ZeldaWindWaker_DragonRoost/track_03.mp3": 57791,
	"./tracks/ZeldaWindWaker_DragonRoost/track_04.mp3": 29536,
	"./tracks/ZeldaWindWaker_DragonRoost/track_05.mp3": 57281,
	"./tracks/ZeldaWindWaker_OutsetIsland/track_01.mp3": 11092,
	"./tracks/ZeldaWindWaker_OutsetIsland/track_02.mp3": 10552,
	"./tracks/ZeldaWindWaker_OutsetIsland/track_03.mp3": 99950,
	"./tracks/ZeldaWindWaker_OutsetIsland/track_04.mp3": 76998,
	"./tracks/ZeldaWindWaker_OutsetIsland/track_05.mp3": 91904,
	"./ui/platforms/3DS.png": 46554,
	"./ui/platforms/Amiga.png": 51882,
	"./ui/platforms/DC.png": 32837,
	"./ui/platforms/DS.png": 95787,
	"./ui/platforms/FDS.png": 29398,
	"./ui/platforms/GB.png": 2874,
	"./ui/platforms/GBA.png": 81889,
	"./ui/platforms/GBC.png": 81772,
	"./ui/platforms/GCN.png": 94386,
	"./ui/platforms/GEN.png": 82230,
	"./ui/platforms/N64.png": 98968,
	"./ui/platforms/NES.png": 61539,
	"./ui/platforms/PC-98.png": 93523,
	"./ui/platforms/PC.png": 634,
	"./ui/platforms/PS1.png": 55789,
	"./ui/platforms/PS2.png": 97696,
	"./ui/platforms/PS3.png": 56658,
	"./ui/platforms/PS4.png": 31937,
	"./ui/platforms/SCD.png": 5307,
	"./ui/platforms/SNES.png": 6268,
	"./ui/platforms/SS.png": 51961,
	"./ui/platforms/Switch.png": 14246,
	"./ui/platforms/Wii.png": 68829,
	"./ui/platforms/WiiU.png": 188,
	"./vitals": 7518,
	"./vitals.js": 7518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;